/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RatedSkill
 */
export interface RatedSkill {
    /**
     * 
     * @type {string}
     * @memberof RatedSkill
     */
    tagHumanId?: string;
    /**
     * 
     * @type {string}
     * @memberof RatedSkill
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof RatedSkill
     */
    rating?: number;
}

/**
 * Check if a given object implements the RatedSkill interface.
 */
export function instanceOfRatedSkill(value: object): value is RatedSkill {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function RatedSkillFromJSON(json: any): RatedSkill {
    return RatedSkillFromJSONTyped(json, false);
}

export function RatedSkillFromJSONTyped(json: any, ignoreDiscriminator: boolean): RatedSkill {
    if (json == null) {
        return json;
    }
    return {
        
        'tagHumanId': json['tagHumanId'] == null ? undefined : json['tagHumanId'],
        'label': json['label'],
        'rating': json['rating'] == null ? undefined : json['rating'],
    };
}

export function RatedSkillToJSON(value?: RatedSkill | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tagHumanId': value['tagHumanId'],
        'label': value['label'],
        'rating': value['rating'],
    };
}

